import { render, staticRenderFns } from "./CreditReports.vue?vue&type=template&id=2c824da2&scoped=true"
import script from "./CreditReports.vue?vue&type=script&lang=js"
export * from "./CreditReports.vue?vue&type=script&lang=js"
import style0 from "./CreditReports.vue?vue&type=style&index=0&id=2c824da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c824da2",
  null
  
)

export default component.exports